import { RouteType } from "types/RouteType";
import EmailAdminStore from "./EmailAdminStore";

/**
 * Admin → Email.
 *
 * THE SCREEN A SHIPPED CARD WAS ALREADY POINTING AT. The `email.sendgrid`
 * readiness check (API capability-readiness.registry.ts) tells an operator to
 * "Open Admin → Email for the reason on the most recent one" and to "Send a test
 * from Admin → Email"; until this route existed both sentences pointed at
 * nothing. Keep the name and the path stable — they are what that text means.
 *
 * `requiresAdmin` is UI gating; the real gate is server-side — `email-config`
 * and `email-sends` are admin-tier, refuse API keys and refuse deactivated
 * accounts (packages/api/src/services/system/email/email-admin.ts).
 */
const emailRoute: RouteType = {
  name: "Email",
  path: "/admin/email",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Email",
      enableRefreshButton: true,
      color: "primary",
      component: () => import("./Email.Header"),
    },
    body: {
      component: () => import("./Email.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["sendgrid", "mail", "email sends", "send ledger", "test email"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
  onEnter: ({ rootStore }) => {
    const store = rootStore.emailAdminViewStore as EmailAdminStore;
    void store?.load();
  },
};

export default emailRoute;
